import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { QRLabelType } from '@/model/qr-label';
import { type QRLabelData } from '@/model/qr-label';
import type { ActivationExhibitors, ArcualInventoryItem } from '@arcual/lib-app-platform';

export const QRLabelsStoreName = 'QRLabelsStore';

export const useQRLabelsStore = defineStore(
  QRLabelsStoreName,
  () => {
    const labelData = ref<QRLabelData | null>(null);

    const setQRLabelData = (type: QRLabelType, items: ActivationExhibitors[] | ArcualInventoryItem[]) => {
      labelData.value = {
        type,
        items,
      };
    };

    /**
     * Reset the store to its initial state
     */
    const reset = () => {
      labelData.value = null;
    };

    return {
      labelData,
      setQRLabelData,
      reset,
    };
  },
  { persist: { paths: ['labelData'] } },
);
